const slider = document.querySelector('.tw-flex.tw-overflow-x-auto');
const dots = document.querySelectorAll('.tw-dot');

function updateDots(index) {
  dots.forEach((dot, i) => {
    dot.classList.toggle('active', i === index);
  });
}

document.querySelectorAll('.tw-next-slide').forEach((button) => {
  button.addEventListener('click', () => {
    slider.scrollBy({ left: slider.clientWidth, behavior: 'smooth' });
    const activeIndex = Math.min(dots.length - 1, Math.floor(slider.scrollLeft / slider.clientWidth) + 1);
    updateDots(activeIndex);
  });
});

document.querySelectorAll('.tw-previous-slide').forEach((button) => {
  button.addEventListener('click', () => {
    slider.scrollBy({ left: -slider.clientWidth, behavior: 'smooth' });
    const activeIndex = Math.max(0, Math.floor(slider.scrollLeft / slider.clientWidth) - 1);
    updateDots(activeIndex);
  });
});

dots.forEach((dot, index) => {
  dot.addEventListener('click', () => {
    slider.scrollTo({ left: index * slider.clientWidth, behavior: 'smooth' });
    updateDots(index);
  });
});

// Initialize first dot as active
updateDots(0);
